
export default {
  getQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r) {
      return unescape(r[2])
    } else {
      return ''
    }
  },
  // 删除数组的最后一位空
  removeEmpty (str) {
    if (str[str.length - 1] === '#') {
      str = str.substring(0, str.length - 1)
    }
    if (str) {
      return str
    } else {
      return null
    }
  },
  // 给数组加select参数
  addSelect (arr, level) {
    let newArr = []
    if (arr) {
      arr.forEach(function (item) {
        if (item) {
          if (level === 'levels_1') {
            newArr.push(
              Object.assign({}, { level: item }, { isSelect: false }, { isHave: true })
            )
          } else {
            newArr.push(
              Object.assign({}, { level: item }, { isSelect: false }, { isHave: false })
            )
          }
        }
      })
    }
    return newArr
  },
  reloadPage () {
    var isPageHide = false
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        window.location.reload()
      }
    })
    window.addEventListener('pagehide', function () {
      isPageHide = true
    })
  }
}
